class MHeader extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      headers: ["header"],
      logos: [".m-logo"],
      topbar: ".m-topbar",
      headerWrapper: ".m-header__wrapper",
      topbarClose: ".m-topbar__close",
    };
    this.classes = {
      scrollUp: "scroll-up",
      scrollDown: "scroll-down",
      stuck: "stuck",
      always: "header-sticky-always",
      headerScrollUp: "header-scroll-up",
      headerScrollDown: "header-scroll-down",
    };
    // State variables
    this.stickyHeader = this.dataset.sticky;
    this.lastScroll = 0;
    this.headerHeight = 0;
    this.extraSpace = 20; // Default
    this.scrollThreshold = 5; // Minimum scroll distance to trigger change
    
    // Bind methods to this instance
    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }
  
  connectedCallback() {
    // Initialize DOM nodes here when element is connected
    this.domNodes = queryDomNodes(this.selectors, this);
    this.init();
  }
  
  init() {
    this.transparentHeader =
      this.domNodes && this.domNodes.headers[0] && this.domNodes.headers[0].dataset.transparent === "true";
    this.initAddon();
    
    // FIXED: Delay initial calculation to ensure DOM is ready
    requestAnimationFrame(() => {
      this.calculateDimensions();
      
      // Log initial state for debugging
      if (window.location.search.includes('debug')) {
        console.log('🔧 Sticky Header Debug Info:', {
          stickyMode: this.stickyHeader,
          headerHeight: this.headerHeight,
          extraSpace: this.extraSpace,
          headerOffsetTop: this.headerOffsetTop
        });
      }
    });
    
    // Add Event Listeners
    // Use passive scroll for better performance
    window.addEventListener("scroll", this.handleScroll, { passive: true });
    window.addEventListener("resize", this.handleResize);
    
    // Recalculate dimensions when switching breakpoints (mobile/desktop)
    document.addEventListener("matchMobile", this.handleResize);
    document.addEventListener("unmatchMobile", this.handleResize);
    
    this.siteNav = new SiteNav(this);
    window.__sfHeader = this;
  }
  
  initAddon() {
    if (typeof Megamenu !== 'undefined') {
      this.megamenu = new Megamenu(this);
    }
    if (Shopify.designMode) {
      MinimogTheme = MinimogTheme || {};
      MinimogTheme && MinimogTheme.Wishlist && MinimogTheme.Wishlist.updateWishlistCount();
    }
  }
  
  calculateDimensions() {
    if (this.domNodes.headerWrapper) {
      this.headerHeight = this.domNodes.headerWrapper.offsetHeight;
      this.headerOffsetTop = this.domNodes.headerWrapper.offsetTop;
    }
    
    let extraSpace = 20;
    // Calculate extra space from other header groups
    const sectionGroups = document.querySelectorAll(".shopify-section-group-header-group");
    sectionGroups.forEach((section) => {
      if (!section.classList.contains("m-section-header") && !section.classList.contains("m-section-scaling-logo")) {
        extraSpace += section.offsetHeight;
      }
    });
    
    const topBar = document.querySelector(".m-topbar");
    if (topBar) extraSpace += topBar.offsetHeight;
    
    this.extraSpace = extraSpace;
    
    // Update CSS variable
    document.documentElement.style.setProperty('--m-header-height', `${this.headerHeight}px`);
  }
  
  handleResize() {
    this.calculateDimensions();
  }
  
  handleScroll() {
    const currentScroll = window.scrollY;
    
    // 1. Safety check for negative scroll (iOS rubber banding)
    if (currentScroll < 0) return;
    
    // 2. Check if scroll difference is significant enough
    const scrollDiff = Math.abs(currentScroll - this.lastScroll);
    if (scrollDiff < this.scrollThreshold && currentScroll > this.extraSpace) {
      return; // Ignore small scroll movements
    }
    
    // 3. Logic when at the top (within extraSpace threshold)
    if (currentScroll <= this.extraSpace) {
      this.classList.remove(
        this.classes.scrollUp, 
        this.classes.stuck, 
        this.classes.always,
        this.classes.scrollDown
      );
      document.body.classList.remove(
        this.classes.headerScrollUp, 
        this.classes.headerScrollDown
      );
      this.lastScroll = currentScroll;
      return;
    }
    
    // 4. Apply base sticky classes based on mode
    if (this.stickyHeader === "on_scroll_up") {
      // Add stuck class for fixed positioning
      if (!this.classList.contains(this.classes.stuck)) {
        this.classList.add(this.classes.stuck);
      }
    } else if (this.stickyHeader === "always") {
      this.classList.add(this.classes.always);
    }
    
    // 5. Scroll Direction Logic
    const isScrollingDown = currentScroll > this.lastScroll;
    const isScrollingUp = currentScroll < this.lastScroll;
    
    if (isScrollingDown) {
      // SCROLLING DOWN
      if (this.stickyHeader === "on_scroll_up") {
        // Only hide header in scroll_up mode
        if (currentScroll > this.headerHeight + this.extraSpace) {
          if (!this.classList.contains(this.classes.scrollDown)) {
            // Remove scroll-up, add scroll-down
            this.classList.remove(this.classes.scrollUp);
            document.body.classList.remove(this.classes.headerScrollUp);
            
            this.classList.add(this.classes.scrollDown);
            document.body.classList.add(this.classes.headerScrollDown);
          }
        }
      }
    } else if (isScrollingUp) {
      // SCROLLING UP
      // Always show header when scrolling up (regardless of previous state)
      if (!this.classList.contains(this.classes.scrollUp)) {
        // Remove scroll-down, add scroll-up
        this.classList.remove(this.classes.scrollDown);
        document.body.classList.remove(this.classes.headerScrollDown);
        
        this.classList.add(this.classes.scrollUp);
        document.body.classList.add(this.classes.headerScrollUp);
      }
    }
    
    this.lastScroll = currentScroll;
  }
  
  disconnectedCallback() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleResize);
    document.removeEventListener("matchMobile", this.handleResize);
    document.removeEventListener("unmatchMobile", this.handleResize);
  }
}

customElements.define("m-header", MHeader);